import React from 'react'

export default function Suppliers() {
  return (
    <div>Suppliers</div>
  )
}
